import { Box } from "@mui/material";
import LinearProgress, { type LinearProgressProps } from "@mui/material/LinearProgress";

import { cn } from "../utils/styling";

type LinearProgressWithLabelProps = LinearProgressProps & {
  fullWidth?: boolean;
  hasAnimation?: boolean;
  parentClassName?: string;
};

export function LinearProgressWithLabel({
  className,
  fullWidth,
  hasAnimation = false,
  parentClassName,
  sx,
  ...rest
}: LinearProgressWithLabelProps) {
  return (
    <Box className={cn("flex flex-col items-center", parentClassName)} sx={{ width: fullWidth ? "100%" : undefined }}>
      <Box className={hasAnimation ? "relative" : ""} sx={{ width: fullWidth ? "100%" : "148px" }}>
        {hasAnimation && (
          <div className="absolute h-full" style={{ width: `${Number(rest.value ?? 0)}%` }}>
            <div className="relative h-full w-full overflow-hidden">
              <div className="animate-progress absolute top-1/2 z-progress_indicator h-[1.2rem] -translate-y-1/2 bg-lds-selection-strong" />
            </div>
          </div>
        )}
        <LinearProgress
          {...rest}
          className={cn(
            "!h-[1.2rem] !overflow-hidden !rounded-ds-pill !bg-lds-background-default !border-ds-subtle",
            "[&_.MuiLinearProgress-barColorPrimary]:!bg-lds-element-primary",
            className
          )}
          sx={sx ? (Array.isArray(sx) ? sx : [sx]) : undefined}
          variant="determinate"
        />
      </Box>
    </Box>
  );
}
